import { render, staticRenderFns } from "./QuoteUpdate.vue?vue&type=template&id=487da520&"
import script from "./QuoteUpdate.vue?vue&type=script&lang=ts&"
export * from "./QuoteUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports